import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[spUpdatedInvoiceNumber]',
})
export class ValidatedInvoiceNumberDirective {
  constructor(private el: ElementRef) {}
  // private regex: RegExp = new RegExp(/^[a-z\d\-/]+$/i);
  private regex: RegExp = new RegExp(/^(?!\-)(?!\/)(?!-*\-$)(?!-*?\-\-)(?!.*\/\/)(?!.*\-\-)(?!.*\-\/)(?!.*\/\-)[a-zA-Z1-9][a-zA-Z0-9-\/]*$/i);
  private specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
  ];
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let current: string = this.el.nativeElement.value;
    let next: string = current.concat(event.key);
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}
